import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initClarity } from './utils/clarity';
import { initSentry } from './utils/sentry';

// if (process.env.NODE_ENV === 'production') {
//   initSentry();
//   initClarity(process.env.REACT_APP_CLARITY_ID);
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

reportWebVitals();
